/*
 * --------------------------------------------------------------------------- *
 * File: datatypeutils.js                                                      *
 * Project: web                                                                *
 * Created Date: 29 Oct 2022                                                   *
 * Author: Vikas K Solegaonkar (vikas.solegaonkar@gmail.com)                   *
 * Copyright (c) 2022 Vikas K Solegaonkar                                      *
 * https://solegaonkar.com                                                     *
 *                                                                             *
 * Last Modified: Mon Nov 07 2022                                              *
 * Modified By: Vikas K Solegaonkar                                            *
 *                                                                             *
 * HISTORY:                                                                    *
 * --------------------------------------------------------------------------- *
 * Date         By     Comments                                                *
 * --------------------------------------------------------------------------- *
 */

import Constants from "../main/constants";
import { Cloud } from "../main/cloud";

const sha1 = require("sha1");

const allDataTypes = {};
var loading = false;

const fetchAllDataTypes = async () => {
  if (!loading) {
    loading = true;
    var response = await Cloud.post(`${Constants.apiBaseUrl}`, {
      action: "LIST_DATA_TYPE",
    });

    if (Array.isArray(response)) {
      response.forEach((d) => {
        allDataTypes[d.name] = {
          name: d.name,
          description: d.description,
          structure: d.structure,
        };
      });
    }
  }
  loading = false;
};

const updateDataType = async (dataType) => {
  if (Object.keys(allDataTypes).includes(dataType.name)) {
    await Cloud.post(`${Constants.apiBaseUrl}`, { data: dataType, action: "SAVE_DATA_TYPE" });
    allDataTypes[dataType.name] = dataType;
  }
  // eslint-disable-next-line no-throw-literal
  else throw "No such Data Type";
};

const createDataType = async (dataType) => {
  if (!Object.keys(allDataTypes).includes(dataType.name)) {
    dataType.id = sha1(dataType.name);
    dataType.context = `${Constants.bank} datatype`;
    await Cloud.post(`${Constants.apiBaseUrl}`, { data: dataType, action: "SAVE_DATA_TYPE" });
  }
  // eslint-disable-next-line no-throw-literal
  else throw "Data Type Already in DB";
};

const getDataTypeNames = () => {
  return Object.keys(allDataTypes);
};

const getDataTypeDetails = (name) => {
  return allDataTypes[name];
};

const checkNameExists = (name) => {
  return Object.keys(allDataTypes).includes(name);
};

const getSampleValue = (type, subType) => {
  if (type === "text") return "";
  if (type === "boolean") return true;
  if (type === "number") return 0;
  if (type === "date") return Date.now();
  if (type === "password") return "";
  if (type === "select") return "";
  if (type === "address") return "afdsf";

  if (type === "list") {
    return [getSampleValue(subType)];
  }

  if (Array.isArray(type)) {
    const o = {};
    type.forEach((f) => {
      o[f.fieldName] = getSampleValue(f.fieldType, f.subType);
    });
    return o;
  } else if (checkNameExists(type)) {
    return getSampleValue(getDataTypeDetails(type).structure);
  }
};

const checkRequiredValues = (value, type, subType) => {
  var good = true;
  if (["text", "password", "number", "select", "date"].includes(type)) {
    good = isNaN(value) && !value.trim() ? false : true;
    return good;
  }

  if (type === "address") return true;

  if (type === "list") {
    value.forEach((v) => (good &= checkRequiredValues(v, subType)));
    return good;
  }

  if (Array.isArray(type)) {
    // If it is a required field or a complex type.
    type.forEach((f) => {
      if (f.required || checkNameExists(f.fieldType) || f.fieldType === "list") {
        good &= checkRequiredValues(value[f.fieldName], f.fieldType, f.subType);
      }
    });
    return good;
  } else if (checkNameExists(type)) {
    return checkRequiredValues(value, getDataTypeDetails(type).structure);
  }
};

const isJsonString = (str) => {
  try {
    JSON.parse(str);
    return true;
  } catch (e) {
    return false;
  }
};

export {
  fetchAllDataTypes,
  updateDataType,
  createDataType,
  getDataTypeNames,
  getDataTypeDetails,
  checkNameExists,
  getSampleValue,
  checkRequiredValues,
  isJsonString,
};
